export default __webpack_public_path__ + "static/pic1-a4814ad1c2c0353c48dc2707d857ffb9.png";